import Vue from 'vue'
import dayjs from 'dayjs'
import isEmpty from '../utils/isEmpty'
import notEmpty from '../utils/notEmpty'
import typeOf from '../utils/typeOf'
import getPropByPath from '../utils/getPropByPath'
import validator, { highlightFormError } from '../utils/validator'
import _ from 'lodash'
import Swal from '../components/Swal'
import * as filters from './filters'
import axios from 'axios'
const CancelToken = axios.CancelToken
import ElementFormVerify from 'element-form-verify'
import qs from 'qs'

// todo: deprecated
function getCharLen (str) {
  let charLen = 0
  for (let i = 0; i < str.length; i++) {
    if ((str.charCodeAt(i) & 0xff00) !== 0) {
      charLen++
    }
    charLen++
  }
  return charLen
}

export function getInitData__ () {
  const validator__ = {}

  for (let k in validator) {
    validator__[k + '__'] = validator[k]
  }

  return {
    ...validator__,
    // todo: deprecated
    options__: {
      dialog: {
        u: '编辑',
        c: '新增',
        r: '查看'
      },
      status: {
        default: ['停用', '启用'],
        opposite: ['启用', '停用'],
        type: ['warning', 'success']
      },
      whether: {
        cn: {
          null: '否',
          '': '否',
          0: '否',
          1: '是'
        },
        type: ['info', 'warning']
      }
    },
    list__: {
      data: [],
      loading: false,
      total: 0,
      query: {},
    },
    prevPageNo__: 1,
    row__: {
      loading: false,
      show: false,
      data: {},
      initData: {},
      obj: null,
      objIs: null,
    },
    dialogStatus__: '',
    normalizer__: null,
    cancelRequest__: {
      list: null,
      r: null
    },
    labelWidth__: '150px', // todo: deprecated
    labelWidthSettled__: false, // todo: deprecated
    retrieving__: false, // todo: deprecated
  }
}

function getMixins ({
  dayjsExtends,
  normalizer
} = {}) {
  normalizer = {
    pageNo: 'pageNo',
    pageSize: 'pageSize',
    total: 'data.total',
    list: ['data', 'data.records', 'data.list'], // 不分页/分页两种情况 data.list为兼容性代码
    r: 'data',
    row: ['id', 'id', 'data'], // todo: deprecated
    ...normalizer
  };

  [
    'isBetween',
    'isSameOrAfter',
    'isSameOrBefore',
    'isToday',
    'isTomorrow',
    'isYesterday',
    'objectSupport',
    'relativeTime',
    'minMax',
    'customParseFormat',
    'duration',
    ...dayjsExtends || []
  ].map(v => {
    dayjs.extend(require(`dayjs/plugin/${v}.js`))
  })

  const globalMethods = {
    $dayjs: dayjs,
    $isEmpty: isEmpty,
    $notEmpty: notEmpty,
    $typeOf: typeOf
  }

  Vue.mixin({
    methods: globalMethods
  })

  Vue.use(Swal)

  Vue.use(ElementFormVerify)

  // todo:
  /*for (let k in globalMethods) {
    Object.defineProperty(Vue.prototype, k, {
      value: globalMethods[k]
    })
  }*/

  if (Vue.prototype._) {
    console.warn('[getMixins] 请勿重复挂载_')
  } else {
    Vue.prototype._ = _
  }

  Object.keys(filters).map(key => {
    if (Vue.prototype[key]) {
      console.warn('[getMixins] 请勿重复注册' + key)
    } else {
      Vue.filter(key, filters[key])
      Object.defineProperty(Vue.prototype, key, {
        value: filters[key]
      })
    }
  })

  return {
    data () {
      return this._.cloneDeep(getInitData__())
    },
    watch: {
      async 'row__.show' (newVal) {
        if (newVal) {
          if (!this.labelWidthSettled__) {
            this.labelWidth__ = await this.getLabelWidth__()
            this.labelWidthSettled__ = true
          }
        } else {
          // 如果弹框readonly状态在弹框关闭动画结束之前改变 将导致弹框的按钮显隐错乱
          setTimeout(() => {
            this.dialogStatus__ = ''
          }, 300)

          // todo: deprecated
          this.onRowDialogClose__ && this.onRowDialogClose__()
          this.row__.data = this._.cloneDeep(this.row__.initData)
          this.$refs.rowForm && this.$refs.rowForm.clearValidate()
          this.row__.loading = false
        }
      }
    },
    /*beforeCreate() {
          for (let k in initData) {
            this[k] = initData[k]
          }
    },*/
    created () {
      // 混入对象的钩子将在组件自身钩子之前调用

      // todo: deprecated
      if (this.api) {
        this.api__ = this.api__ || this.api
        console.warn('[plain-kit] this.api已废弃 请使用this.api__')
      } else if (!this.api__) {
        throw new Error('[plain-kit] data中未找到api__')
      }

      /**
       * 初始化接口参数、返回值格式
       */

      // todo: deprecated
      if (this.key__) {
        if (this.normalizer__) {
          if (this.key__[1]) {
            this.normalizer__.row[0] = this.key__[1]
          }
        } else {
          this.normalizer__ = {
            row: [
              this.key__[1]
            ]
          }
        }
        if (this.key__[0]) {
          this.normalizer__.row[1] = this.key__[0]
        }
        this.normalizer__.r = 'data'
      }

      this.normalizer__ = {
        ...normalizer,
        ...this.normalizer__
      }

      // todo: deprecated
      if (typeof this.normalizer__?.row?.[2] === 'string') {
        this.normalizer__.r = this.normalizer__.row[2]
      }

      if (!(this.normalizer__.list instanceof Array)) {
        this.normalizer__.list = [this.normalizer__.list]
      }
      this.list__.query = {
        [this.normalizer__.pageNo]: 1,
        [this.normalizer__.pageSize]: this.list__.query[this.normalizer__.pageSize] || 10,
        ...this.list__.query
      }

      if (Object.getOwnPropertyNames(this.row__.data).length > 0) {
        this.row__.initData = this._.cloneDeep(this.row__.data)
      }
      typeof this.init__ === 'function' ? this.init__('init') : this.getList__()
    },
    mounted () {
      // fixing: 没有声明的筛选参数无法重置
      if (this.$refs.filterForm?.fields) {
        let obj = {}
        Array.from(this.$refs.filterForm.fields, v => v.labelFor)?.map(v => {
          obj[v] = undefined
        })
        this.list__.query = {
          ...obj,
          ...this.list__.query,
        }
      }

      this.$watch('list__.query', newVal => {
        if (!this.getListThrottle__) {
          this.getListThrottle__ = this._.throttle(() => {
            const callback = valid => {
              if (valid) {
                const pageNoField = this.normalizer__.pageNo

                // 如果改变的不是页码 页码重置为1
                if (this.prevPageNo__ === newVal[pageNoField]) {
                  this.list__.query[pageNoField] === 1 ?
                    (typeof this.init__ === 'function' ? this.init__('queryChange') : this.getList__()) :
                    this.list__.query[pageNoField] = 1
                } else {
                  // 刷新列表
                  typeof this.init__ === 'function' ? this.init__('pageNoChange') : this.getList__()
                }
                this.prevPageNo__ = newVal[pageNoField]
              }
              // 执行钩子
              this.onQueryChange__ && this.onQueryChange__(valid)
            }
            if (this.$refs.filterForm) {
              this.$refs.filterForm.validate(callback)
            } else {
              console.warn('[plain-kit] 未找到$refs.filterForm')
              callback(true)
            }
          }, 500, {
            leading: false, // true会导致：如果调用≥2次 则至少触发2次 但此时可能只期望触发1次
            trailing: true
          })
        }

        this.getListThrottle__()
      }, {
        deep: true
      })
    },
    destroyed () {
      // 页面销毁时如果还有查询请求 中止掉
      for (let k in this.cancelRequest__) {
        this.cancelRequest__[k] && this.cancelRequest__[k]()
      }
      /*    let initData = getInitData__()
          for (let k in this.$data) {
            // delete this[k]
            this[k] = initData[k]
          }*/
      Object.assign(this.$data, getInitData__())
    },
    methods: {
      // todo: deprecated
      async getLabelWidth__ () {
        return new Promise((resolve, reject) => {
          this.$nextTick(() => {
            let maxWords = 4
            for (let v of document.querySelectorAll('.el-form--label-right .el-form-item>label')) {
              if (v.innerText) {
                let len = getCharLen(v.innerText)
                if (len > maxWords) {
                  maxWords = len
                }
              }
            }
            // 50 64 78
            resolve(22 + maxWords * 7 + 'px')
          })
        })
      },
      // todo: deprecated
      getRowHandler__ (row) {
        return {
          c: () => {
            this.row__.show = true
          },
          r: () => {
            this.row__.show = true

            // todo: deprecated
            // 放在dataGetter__之后执行 如果dataGetter__已执行过 则不执行
            setTimeout(() => {
              let loading = this.$loading({ lock: true })
              const result = this.retrieve__(this.afterRetrieve__)
              if (result instanceof Promise) {
                result.finally(e => {
                  loading.close()
                })
              } else {
                loading.close()
              }
            }, 0)

          },
          u () {
            this.r()
          },
          d: () => {
            const loading = this.$loading({
              lock: true,
              // text: 'Loading',
              // spinner: 'el-icon-loading',
              // background: 'rgba(0, 0, 0, 0.7)'
            })
            this.api__.d({
              [this.normalizer__.row[1]]: row[this.normalizer__.row[0]]
            }).then(res => {
              if (this.list__.data?.length === 1) {
                if (this.list__.query[this.normalizer__.pageNo] === 1) {
                  typeof this.init__ === 'function' ? this.init__('d', res) : this.getList__()
                } else {
                  this.list__.query[this.normalizer__.pageNo]--
                }
              } else {
                typeof this.init__ === 'function' ? this.init__('d', res) : this.getList__()
              }
              this.$message.success('操作成功')
            }).finally(e => {
              loading.close()
            })
          },
          updateStatus: () => {
            const loading = this.$loading({ lock: true, })
            this.api__.updateStatus({
              [this.normalizer__.row[1]]: row[this.normalizer__.row[0]],
              status: {
                0: 1,
                1: 0
              }[row.status]
            }).then(res => {
              typeof this.init__ === 'function' ? this.init__({
                0: 'enable',
                1: 'disable'
              }[row.status], res) : this.getList__()
              this.$message.success('操作成功')
            }).finally(e => {
              loading.close()
            })
          },
          ...this.rowHandler__,
        }
      },
      // todo: deprecated
      handleRow__ (intention, row, customApi) {
        this.dialogStatus__ = intention
        if (intention !== 'c' && row) {
          if (this.api__.r) {
            this.row__.objIs = 'param'
            this.row__.obj = { [this.normalizer__.row[1]]: row[this.normalizer__.row[0]] }
          } else {
            this.row__.objIs = 'data'
            this.row__.obj = row
          }
        }

        // todo: deprecated
        if (typeof customApi === 'function' && intention !== 'c') {
          this.api__[intention === 'u' ? 'r' : intention] = customApi
        }

        this.getRowHandler__(row)[intention]()
      },
      // todo: deprecated
      doHandleRow__ (handleParam) {
        this.$refs['rowForm'].validate(valid => {
          if (valid) {
            this.row__.loading = true
            let param = this.row__.data
            if (handleParam instanceof Function) {
              handleParam()
            } else if (this._.isPlainObject(handleParam)) {
              param = handleParam
            }
            this.api__[this.dialogStatus__](param).then(res => {
              typeof this.init__ === 'function' ? this.init__(this.dialogStatus__, res) : this.getList__()
              this.row__.show = false
              this.$message.success('操作成功')
            }).catch(e => {
              this.row__.loading = false
            })
          } else {
            highlightFormError()
          }
        })
      },

      resetQuery__ () {
        this.$refs.filterForm.resetFields()
      },
      getList__ (callback) {
        this.list__.loading = true
        this.list__.data.length = 0
        this.api__.list(this.list__.query, 'param', {
          cancelToken: new CancelToken(c => {
            // executor 函数接收一个 cancel 函数作为参数
            this.cancelRequest__.list = c
          })
        }).then(res => {
          // 在快速切换页面时（上一个页面的接口调用还未结束就切换到下一个页面） 在data被清空的空隙 this.normalizer__为空
          // 不能采用给this.normalizer__赋初值来解决 因为自定义的全局normalizer会被该初值覆盖
          if (this.normalizer__) {
            for (let v of this.normalizer__.list) {
              const list = getPropByPath(res, v)
              if (list instanceof Array) {
                this.list__.data = list
                this.list__.total = getPropByPath(res, this.normalizer__.total)
                break
              }
            }
            if (isEmpty(this.list__.data)) {
              this.list__.total = 0
            }
          }
          callback?.(res)
        }).finally(e => {
          this.cancelRequest__.list = null
          this.list__.loading = false
        })
      },
      retrieve__ (afterRetrieve, beforeRetrieve) {
        // todo: deprecated
        // 加锁：兼容0.2.x 避免重复调用retrieve__
        if (this.retrieving__) {
          return
        }
        this.retrieving__ = true

        if (typeof beforeRetrieve === 'function') {
          beforeRetrieve()
        }

        const callback = rowData => {
          if (typeof afterRetrieve === 'function') {
            // todo: deprecated
            // todo: afterRetrieve(rowData)
            // 坑：
            /*
              let obj = { a: 1 }
              obj = {
                ...obj,
                ...(obj => { // 该方法中对obj的修改不会对上一行中的obj生效
                  obj.x = 1
                })()
              }
            */
            const result = afterRetrieve(rowData)
            if (result) {
              rowData = {
                ...rowData,
                ...result
              }
            }
          }
          // 将接口返回值混入row__.data
          this.row__.data = {
            ...this.row__.data,
            ...rowData
          }
        }

        if (this.api__.r) {
          return this.api__.r(
            this.row__.obj,
            this.row__.objIs,
            {
              cancelToken: new CancelToken(c => {
                // executor 函数接收一个 cancel 函数作为参数
                this.cancelRequest__.r = c
              })
            })
          .then(res => {
            callback(getPropByPath(res, this.normalizer__.r))
          })
          .finally(() => {
            this.cancelRequest__.r = null
            // todo: deprecated
            // 微任务会先于宏任务执行 如果接口耗时够短 仍然可能先于handleRow__('r') 所以需要加setTimeout
            setTimeout(() => {
              this.retrieving__ = false
            }, 2)
          })
        }
        // todo: deprecated
        else {
          callback(this.row__.obj)
          // 保证其在handleRow__('r')之后执行
          setTimeout(() => {
            this.retrieving__ = false
          }, 2)
        }
      },
      c__ () {
        this.dialogStatus__ = 'c'
        this.row__.show = true
      },
      r__ (obj, objIs = this.api__.r === false ? 'data' : 'param') {
        this.row__.objIs = objIs
        if (objIs === 'data') {
          if (!(this._.isPlainObject(obj))) {
            throw Error('[r__] 直接使用列表数据时，第一个参数的类型需为object')
          }
          this.row__.obj = this._.cloneDeep(obj)
        } else {
          if (objIs === 'param' && !(this._.isPlainObject(obj) || obj instanceof FormData)) {
            throw Error('[r__] 第一个参数的类型需为object|FormData')
          }
          this.row__.obj = obj
        }
        this.dialogStatus__ = 'r'
        this.row__.show = true
      },
      u__ (obj, objIs = this.api__.r === false ? 'data' : 'param') {
        this.row__.objIs = objIs
        if (objIs === 'data') {
          if (!(this._.isPlainObject(obj))) {
            throw Error('[u__] 直接使用列表数据时，第一个参数的类型需为object')
          }
          this.row__.obj = this._.cloneDeep(obj)
        } else {
          if (objIs === 'param' && !(this._.isPlainObject(obj) || obj instanceof FormData)) {
            throw Error('[u__] 第一个参数的类型需为object|FormData')
          }
          this.row__.obj = obj
        }
        this.dialogStatus__ = 'u'
        this.row__.show = true
      },
      d__ (obj, objIs = 'param') {
        this.row__.objIs = objIs
        if (!(this._.isPlainObject(obj) || obj instanceof FormData)) {
          throw Error('[d__] 第一个参数的类型仅能为object|FormData')
        }
        this.list__.loading = true
        this.api__.d(obj, objIs).then(res => {
          if (this.list__.data?.length === 1) {
            if (this.list__.query[this.normalizer__.pageNo] === 1) {
              typeof this.init__ === 'function' ? this.init__('d', res) : this.getList__()
            } else {
              this.list__.query[this.normalizer__.pageNo]--
            }
          } else {
            typeof this.init__ === 'function' ? this.init__('d', res) : this.getList__()
          }
          this.$message.success('操作成功')
        }).finally(e => {
          this.list__.loading = false
        })
      },
      updateStatus__ (obj, objIs = 'param') {
        this.row__.objIs = objIs
        if (!(this._.isPlainObject(obj) || obj instanceof FormData)) {
          throw Error('[updateStatus__] 第一个参数的类型仅能为object|FormData')
        }
        this.list__.loading = true
        this.api__.updateStatus(obj, objIs).then(res => {
          typeof this.init__ === 'function' ? this.init__('updateStatus', res) : this.getList__()
          this.$message.success('操作成功')
        }).finally(e => {
          this.list__.loading = false
        })
      },
      dataGetter__ (afterRetrieve, beforeRetrieve) {
        // 仅查看和编辑才调用
        if (!['r', 'u'].includes(this.dialogStatus__)) {
          return
        }

        return this.retrieve__(afterRetrieve, beforeRetrieve)
      },
      submit__ (beforeSubmitting) {
        let param = this.row__.data
        if (beforeSubmitting) {
          if (beforeSubmitting instanceof Function) {
            beforeSubmitting()
          } else if (this._.isPlainObject(beforeSubmitting) || beforeSubmitting instanceof FormData) {
            param = beforeSubmitting
          } else {
            console.error('[plain-kit] submit__的参数类型仅能为function|object|FormData')
          }
        }
        return this.api__[this.dialogStatus__](param).then(res => {
          this.row__.obj = null
          this.row__.objIs = null
          typeof this.init__ === 'function' ? this.init__(this.dialogStatus__, res) : this.getList__()
          this.$message.success('操作成功')
        })
      },
    }
  }
}

export default getMixins
